import Footer from '../../components/Footer';
import Gnb from '../../components/Gnb';
import UFOGameContainer from '../../components/UFOGame/UFOGameContainer';
import {} from './UFOGame.styled';

export default function UFOGame() {
  return (
    <>
      <Gnb />
      <UFOGameContainer />
      <Footer />
    </>
  );
}
